/**
 * SearchWordRegisterContainer
 * --
 */
import { useEffect, useState } from 'react';
import SearchWordRegisterPresenter from './SearchWordRegisterPresenter';
import { useGetSearchWords } from 'hooks/SearchWordHooks';
import { useGetProducts } from 'hooks/ProductHooks';
const SearchWordRegisterContainer = () => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  const [searchWordList, setSearchWordList] = useState([]);
  /* ===== VARIABLE ===== */
  const { data: ProductList } = useGetProducts({
    application_status: 'APPROVE',
  });
  const response = useGetSearchWords();
  useEffect(() => {
    if (response && response?.data) {
      const { data } = response.data;
      setSearchWordList(data?.sort((a, b) => a.order - b.order));
    }
  }, [response]);
  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <>
      <SearchWordRegisterPresenter
        searchWordList={searchWordList}
        setSearchWordList={setSearchWordList}
        productList={ProductList?.data}
      />
    </>
  );
};

export default SearchWordRegisterContainer;
